import { render, staticRenderFns } from "./task-form.vue?vue&type=template&id=8a6e065e&"
import script from "./task-form.vue?vue&type=script&lang=js&"
export * from "./task-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports